export default __webpack_public_path__ + "static/media/Notice.a0ae3020.svg";